import { useQuery } from '@tanstack/react-query';
import { default as accessTariffsService } from "../../services/accessTariffs";
import { 
  IStepContractFormData
} from '../../types/stepsFormData';


type UseAccessTariffsProps  = {
  gas: false;
  power: IStepContractFormData["power"];
} | {
  gas: true;
}

export const useAccessTariffs = (props: UseAccessTariffsProps) => {

  if (!props.gas) {

    const isReady = props.power !== null || props.power !== 0;

    return useQuery({
      queryKey: ['accessTariffs', props.power],
      queryFn: () => accessTariffsService.fetchAccessTariffs({
        power: props.power
      }),
      enabled: isReady,
      staleTime: 1000 * 60 * 30
    })

  } else {

    return useQuery({
      queryKey: ['gasAccessTariffs'],
      queryFn: () => accessTariffsService.fetchGasAccessTariffs(),
      staleTime: 1000 * 60 * 30
    })

  }
  
}